// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectNative_root__qSUwd","sSmall":"SelectNative_sSmall__J9Sx-","error":"SelectNative_error__27GqQ","disabled":"SelectNative_disabled__3ix9r"};